import { styled } from '@mui/material/styles'

export const ServiceProductListContainer = styled('div', {
  name: 'ServiceProductListContainer',
  slot: 'Root',
  skipSx: true,
})`
  display: flex;
  flex-direction: column;
  width: 573px;
`
